import Access from './access.vue'
import Role from './role.vue'
import User from './user.vue'
import Personal from './personal.vue'
import ThirdApp from './thirdApp.vue'
import Config from './config.vue'
import AdminLists from './adminLists.vue'
import Company from './company.vue'
export default {
	AdminLists,
	Role,
	User,
	Access,
	Personal,
	ThirdApp,
	Config,
	Company
}



// WEBPACK FOOTER //
// ./src/views/user/index.js